import React from 'react';
import '../../../v2-theme.css';

/**
 * V2Badge Component
 *
 * Status badge with v2 design system styling
 *
 * @param {string} variant - 'primary' | 'secondary' | 'outline' | 'success' | 'warning' | 'danger' | 'info'
 * @param {string} size - 'sm' | 'md' | 'lg'
 * @param {React.ReactNode} children - Badge content
 */
const V2Badge = ({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}) => {
  const getVariantClass = () => {
    switch (variant) {
      case 'primary':
        return 'v2-badge-primary'; // Steel background
      case 'secondary':
        return 'v2-badge-secondary'; // Dark steel background
      case 'outline':
        return 'v2-badge-outline'; // Outlined
      case 'success':
        return 'v2-badge-success'; // Green
      case 'warning':
        return 'v2-badge-warning'; // Orange
      case 'danger':
        return 'v2-badge-danger'; // Red
      case 'info':
        return 'v2-badge-info'; // Blue
      case 'gold':
        return 'v2-badge-gold'; // Gold (for admin/professional)
      default:
        return 'v2-badge-primary';
    }
  };

  const getSizeClass = () => {
    switch (size) {
      case 'sm':
        return 'v2-badge-sm';
      case 'lg':
        return 'v2-badge-lg';
      case 'md':
      default:
        return 'v2-badge-md';
    }
  };

  const badgeClasses = [
    'v2-badge',
    getVariantClass(),
    getSizeClass(),
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={badgeClasses} {...props}>
      {children}
    </span>
  );
};

export default V2Badge;
